import React from 'react'
import { EntityDetailView } from '@/components/entity/EntityDetailView'

export function ArchitectDetail() {
  return <EntityDetailView entityType="architect" />
}

